import { AutoSkipCitationsSection } from '@/components/astro/new-design/sections/auto-skip-citations';
import { BrandLogosSection } from '@/components/astro/new-design/sections/brand-logos';
import { CustomerTestimonialsShortSection } from '@/components/astro/new-design/sections/customer-testimonials-short';
import { EduBannerSection } from '@/components/astro/new-design/sections/edu-banner';
import { FaqSection } from '@/components/astro/new-design/sections/faq';
import { FeaturesCardSection } from '@/components/astro/new-design/sections/features-card';
import { HeroHeadingVideo } from '@/components/astro/new-design/sections/hero-heading-video';
import { PricingComparisonSection } from '@/components/astro/new-design/sections/pricing-comparison';
import { ProductOverflowImageSection } from '@/components/astro/new-design/sections/product-overflow-image';
import { SaveTimeByChoosingSection } from '@/components/astro/new-design/sections/save-time-by-choosing';
import { SoundsNaturalEvenAtSpeedSection } from '@/components/astro/new-design/sections/sounds-natural-even-at-speed';
import { TakeNotesOnTheGoSection } from '@/components/astro/new-design/sections/take-notes-on-the-go';
import { VoiceDemoSection } from '@/components/astro/new-design/sections/voice-demo';
import { WhatDoPeopleThinkSection } from '@/components/astro/new-design/sections/what-do-people-think';
import { WorldClassListeningSection } from '@/components/astro/new-design/sections/world-class-listening';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';

export function AudioPage() {
  return (
    <>
      <NavBar />
      <HeroHeadingVideo
        title={
          <h1
            className='block text-center text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[48px] sm:leading-[51px] lg:text-[68px] lg:leading-[73px]'
            slot='title'
          >
            <span className='text-azure-455'>Listen</span> to Academic Papers,
            Books, and PDFs
          </h1>
        }
      >
        <div
          className='flex w-full justify-center text-center text-[16px] leading-[24px] font-[500] text-neutral-840 sm:text-[24px] lg:text-[20px] lg:leading-[30px]'
          slot='text'
        >
          Save time by listening to papers anywhere, in your spare time
        </div>
      </HeroHeadingVideo>
      <EduBannerSection />
      <BrandLogosSection />
      <VoiceDemoSection />
      <CustomerTestimonialsShortSection />
      <ProductOverflowImageSection />
      <WorldClassListeningSection />
      <TakeNotesOnTheGoSection />
      <AutoSkipCitationsSection />
      <SaveTimeByChoosingSection />
      <SoundsNaturalEvenAtSpeedSection />
      <WhatDoPeopleThinkSection />
      <PricingComparisonSection />
      <FeaturesCardSection />
      <FaqSection />
      <Footer />
    </>
  );
}
